import {
  Directive,
  ElementRef,
  Renderer2,
  OnInit,
  OnDestroy,
  ComponentRef,
  ViewContainerRef,
  inject, Input
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SvgImagesComponent } from "../ui/svg-images/svg-images.component";

@Directive({
  selector: '[appFullscreenToggle]',
  standalone: true,
})
export class FullscreenToggleDirective implements OnInit, OnDestroy {
  private isFullscreen = false;
  private button!: HTMLElement;
  private svgComponentRef?: ComponentRef<SvgImagesComponent>;

  private el = inject(ElementRef);
  private renderer = inject(Renderer2);
  private translate = inject(TranslateService);
  private vcr = inject(ViewContainerRef);

  @Input() right = '0.5rem';
  @Input() top = '0.375rem';

  ngOnInit(): void {
    this.createToggleButton();
  }

  ngOnDestroy(): void {
    this.button?.remove();
    this.svgComponentRef?.destroy();
  }

  private createToggleButton(): void {
    this.button = this.renderer.createElement('button');
    this.renderer.setAttribute(this.button, 'title', this.getTitle());

    this.renderer.addClass(this.button, 'text-gray-500');
    this.renderer.addClass(this.button, 'fullscreen-toggle');
    this.renderer.setStyle(this.button, 'position', 'absolute');
    this.renderer.setStyle(this.button, 'top', this.top);
    this.renderer.setStyle(this.button, 'right', this.right);

    this.renderer.listen(this.button, 'click', () => this.toggleFullscreen());

    this.renderer.addClass(this.el.nativeElement, 'fullscreen-toggle');
    this.renderer.appendChild(this.el.nativeElement, this.button);
    this.insertSvgIcon();
  }

  private getTitle(): string {
    const key = this.isFullscreen ? 'app.exitFullscreen' : 'app.fullscreen';
    return this.translate.instant(key);
  }

  private toggleFullscreen(): void {
    const container = this.el.nativeElement;

    if (!this.isFullscreen) {
      container.requestFullscreen();
      this.isFullscreen = true;
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
        this.isFullscreen = false;
      }
    }

    this.insertSvgIcon();
  }

  private insertSvgIcon(): void {
    // Clean up old component if it exists
    this.svgComponentRef?.destroy();

    this.svgComponentRef = this.vcr.createComponent(SvgImagesComponent);
    this.svgComponentRef.instance.svgName = this.isFullscreen
      ? 'arrows-pointing-in'
      : 'arrows-pointing-out';

    // Move component DOM inside button
    this.renderer.appendChild(this.button, this.svgComponentRef.location.nativeElement);

    // Update tooltip
    this.renderer.setAttribute(this.button, 'title', this.getTitle());
  }
}
